<template>
  <table class="table table-bordered table-striped mb-none">
    <thead>
      <tr>
        <th class="center"><input type="checkbox" v-model="selectAll"></th>
        <th  tabindex="0" v-for="key in columnsName"
          @click="((toSort[key] > 0) ? sortBy(key) : '')"
          :class="((toSort[key] > 0) ? ((sortOrders[key] > 0) ? 'sorting_asc' : 'sorting_desc') : '')">
          {{ key }}&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="entry in filteredData"  class="row-hover">
        <td class="center"><input type="checkbox"  v-model="select" :value="entry.element_id" @click="selectProvider"></td>
        <td v-for="key in columns" v-html="entry[key]"></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'Grid',
  props: ['data','columns','sortColumns','loadData','columnsName'],
  
  data: function () {
    var sortOrders = {}
    this.columns.forEach(function (key) {
      sortOrders[key] = 1
    })

    
    var toSort = {}
    this.sortColumns.forEach(function (key) {
      toSort[key] = 1
    })


    return {
      sortKey: '',
      sortOrders: sortOrders,
      toSort: toSort,
      rliss:'',
      admin:'',
      selected:[],
    }
  },

  computed: 
  {

    filteredData: function () {

      var sortKey = this.sortKey
      var order = this.sortOrders[sortKey] || 1
      var data = this.data

      return data
    },

    select: {
      get: function() {
          return this.selected;
      },
      set: function(val) {
          this.selected = val;
          //this.$parent.$emit("userupdated", this.selected);
          this.$parent.selected_agencies = this.selected;
          this.$parent.show_preview = this.selected.length;
      },
    },

    selectAll: {
      get: function () {
          return this.data ? this.selected.length == this.data.length : false;
      },
      set: function (value) {
          var selected = [];

          if (value) {
              this.data.forEach(function (user) {
                  selected.push(user.element_id);
              });
          }

          this.selected = selected;
          //this.$parent.$emit("userupdated", this.selected);  
          this.$parent.selected_agencies = this.selected;
          this.$parent.show_preview = this.selected.length;
        }
    }
  },
  methods: 
  {

    sortBy: function (key) {
      this.sortKey = key
      this.$parent.sort = key;
      this.$parent.sortOrder = this.sortOrders[key];
      this.$parent.newStart();
      this.sortOrders[key] = this.sortOrders[key] * -1

    },

    selectProvider: function () {
      //this.$parent.$emit("userupdated", this.selected);
      this.$parent.selected_agencies = this.selected;
    },
  }
}
</script>
